import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoAbastecimentos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoesabastecimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoAbastecimento({ payload }) {
  try {
    const { idoperacaoabastecimento, params } = payload;

    yield call(
      api.delete,
      `movimentacoesabastecimentos/${idoperacaoabastecimento}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoabastecimento, params } = payload;

    yield call(api.post, 'movimentacoesabastecimentos', operacaoabastecimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { movi_codigo } = payload;

    const { data } = yield call(
      api.get,
      `movimentacoesabastecimentos/${movi_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoabastecimentos, params } = payload;

    yield call(api.put, 'movimentacoesabastecimentos', operacaoabastecimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'movimentacoesabastecimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoabastecimento/OPERACAOABASTECIMENTOS_IN_REQUEST',
    requestOperacaoAbastecimentos
  ),
  takeLatest(
    '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO',
    deleteOperacaoAbastecimento
  ),
  takeLatest(
    '@operacaoabastecimento/SUCCESS_REMOVE',
    requestOperacaoAbastecimentos
  ),
  takeLatest('@operacaoabastecimento/STORE_OPERACAOABASTECIMENTO', store),
  takeLatest('@operacaoabastecimento/FIND_OPERACAOABASTECIMENTO', find),
  takeLatest('@operacaoabastecimento/UPDATE_OPERACAOABASTECIMENTO', update),
  takeLatest('@operacaoabastecimento/RECORD_FILTERING', applyedFilters),
]);
